
const $productMetaFields = document.getElementById("productMetaFields");
const $sizeDL = document.getElementById("sizeDL");

function hideSizeDL() {
    if($sizeDL) {
        $sizeDL.style.display = "none";
    }
}

function initSizeTable(json) {
    try {
        const $sizeTable = document.getElementById("sizeTable");

        if($sizeTable) {
            const $sizeTableHead = document.getElementById("sizeTableHead");
            const $sizeTableBody = document.getElementById("sizeTableBody");

            const allLabels = json.flatMap(function (data) {
                return data.fields.map(function (field) {
                    if(field.is_common === 0) {
                        return field.label;
                    } else {
                        return null;
                    }
                });
            });

            // 表の項目（Head）
            const labels = Array.from(new Set(allLabels)).filter(function (item) {
                return item !== null;
            });

            if(labels.length === 0) {
                hideSizeDL();
                return;
            }

            // Headコンテンツを挿入
            labels.forEach(function (label) {
                const $strong = document.createElement("strong");

                if(label === "重さ") {
                    $strong.innerText = label + "(g)";
                } else {
                    $strong.innerText = label;
                }

                const $td = document.createElement("td");
                $td.appendChild($strong);
                $sizeTableHead.appendChild($td);
            });

            // Bodyコンテンツを挿入
            json.forEach(function (data) {
                let size = data.label;
                if(size === "") {
                    size = "ワンサイズ";
                }

                const values = [];

                labels.forEach(function (label) {
                    data.fields.forEach(function (field) {
                        if(field.label === label) {
                            if(field.is_common === 0) {
                                values.push(field.value);
                            }
                        }
                    });
                });

                const $tr = document.createElement("tr");

                const $strong = document.createElement("strong");
                $strong.innerText = size;

                const sizeElem = document.createElement("td");
                sizeElem.appendChild($strong);
                $tr.appendChild(sizeElem);

                values.forEach(function (value) {
                    const $td = document.createElement("td");
                    $td.innerText = value;
                    $tr.appendChild($td);
                });

                $sizeTableBody.appendChild($tr);
            });
        }
    } catch (e) {
        hideSizeDL();
    }
}

function initSpecs(json) {
    const specValues = json.flatMap(function (data) {
        const values = [];

        data.fields.map(function (field) {
            if(field.is_common === 1) {
                let value = field.value;
                if(field.unit) {
                    value = value + field.unit;
                }
                values.push(field.label + "," + value);
            }
        });

        return values;
    });

    const filteredValues = Array.from(new Set(specValues));

    filteredValues.forEach(function (value) {
        const valueList = value.split(",");

        const $dt = document.createElement("dt");
        $dt.innerText = valueList[0];

        const $dd = document.createElement("dd");
        $dd.innerText = valueList[1];

        const $dl = document.createElement("dl");
        $dl.classList.add("product-dl");

        $dl.appendChild($dt);
        $dl.appendChild($dd);

        if($sizeDL) {
            $productMetaFields.insertBefore($dl, $sizeDL);
        } else {
            $productMetaFields.appendChild($dl);
        }
    });
}

if($productMetaFields) {
    const json = JSON.parse($productMetaFields.dataset.json);
    initSizeTable(json);
    initSpecs(json)
}